import { urlEndsWithSpecialLocation } from "@modules/location/special-locations.ts"
import { isMobile } from "@modules/util/device"

const cityAddressesSelectElement = () =>
    isMobile()
        ? document.querySelector<HTMLSelectElement>('select[name="address"]')
        : document.querySelector<HTMLDivElement>(".adressenwahl")
const cityAddressesSelectDropdownElement = () =>
    document.querySelector<HTMLDivElement>(".adressenwahl .dropdown-toggle")
const containerElementMobile = () => document.querySelector(".location-search-extra")

export function cityAddressesSelectEnablePc() {
    if (isMobile()) {
        return
    }
    cityAddressesSelectElement()?.classList.remove("disabled")
    cityAddressesSelectDropdownElement()?.classList.remove("disabled")
}

export function cityAddressesSelectDisablePc() {
    if (isMobile()) {
        return
    }
    cityAddressesSelectElement()?.classList.add("disabled")
    cityAddressesSelectDropdownElement()?.classList.add("disabled")
}

export function hideCityAddressesMobile() {
    if (isMobile()) {
        containerElementMobile()?.classList.add("hidden")
    }
}

export function showCityAddressesMobile() {
    if (isMobile()) {
        containerElementMobile()?.classList.remove("hidden")
    }
}

export function setCityAddresses(addresses?: Record<string, { ShowText: string; F_EAID: string }>) {
    if (!addresses || urlEndsWithSpecialLocation(window.location.href)) {
        hideCityAddressesMobile()
        cityAddressesSelectDisablePc()
        return
    }
    const keys = Object.keys(addresses)
    if (keys.length === 0) {
        hideCityAddressesMobile()
        cityAddressesSelectDisablePc()
        return
    }

    let select = cityAddressesSelectElement()
    if (!select) {
        select = document.createElement("select")
        select.name = "address"
        document.querySelector(".custom.select.change-address-menu")?.append(select)
    }
    const addressOptions = keys
        .map((key) => {
            if (addresses[key]?.F_EAID) {
                return `<option value="${addresses[key].F_EAID}">${addresses[key].ShowText}</option>`
            }
            // TODO fix / remove... for some reason data structure is not the same between CC and YII. below comes CC, above is YII
            // @ts-expect-error well well well
            if (typeof addresses[key] === "object" && addresses[key][0]?.F_EAID) {
                // @ts-expect-error well well well
                return `<option value="${addresses[key][0].F_EAID}">${addresses[key][0].ShowText}</option>`
            }
            return ""
        })
        .join("")
    select.innerHTML = `<option value="" selected="" disabled="" hidden="">Adressen der Stadt</option><option value="">Keine Adresse</option>${addressOptions}`
    containerElementMobile()?.classList.remove("hidden")
    cityAddressesSelectEnablePc()
}

function updateCityAdressesSelectPc() {
    if (isMobile()) {
        return
    }
    const cityAddressElements = cityAddressesSelectElement()?.querySelectorAll("a[data-eaid]")
    if (cityAddressElements?.length) {
        for (const element of cityAddressElements) {
            element.addEventListener("click", (event) => {
                const target = (event.target as HTMLElement).closest("a")
                const newAddress = target?.getAttribute("data-eaid")
                if (!newAddress) {
                    return
                }
                event.preventDefault()

                const newUrl = new URL(window.location.href)
                newUrl.searchParams.set("adresse", newAddress)
                newUrl.searchParams.delete("page")

                window.location.href = newUrl.href
            })
        }
        cityAddressesSelectEnablePc()
    } else {
        cityAddressesSelectDisablePc()
    }
}

// if no addresses are available backend will not send the select element. This is a fix so that mobile doesnt have a blue stripe shown in the location popup
if (!cityAddressesSelectElement()) {
    hideCityAddressesMobile()
}

if (urlEndsWithSpecialLocation(window.location.href)) {
    hideCityAddressesMobile()
}

updateCityAdressesSelectPc()
